export const CHANGE_LANG = '@changeLang';

export const LOAD_TRANSLATIONS_SUCCESS = '@loadTranslations/success';
export const LOAD_TRANSLATIONS_FAILED = '@loadTranslations/failed';

export const LOAD_DATA_TRANSLATIONS_SUCCESS = '@loadDataTranslations/success';
export const LOAD_DATA_TRANSLATIONS_FAILED = '@loadDataTranslations/failed';

export const IS_FETCHING = '@isFetchingTranslations';